import Api from "./api"

const fetchIndexPageConfig = () => {
    return Api().get('/common/page-config')
        .then(response => {
            return response
        })
}

export {fetchIndexPageConfig}